import React from "react";
import {Link} from "react-router-dom";
import {useHasPermission} from "../../hooks/permission";

const EditButton = ({ to, permission }) => {
    const hasAccess = useHasPermission(permission);

    if(permission && !hasAccess){
        return '';
    }

    return (
        <Link to={to} className="btn btn-outline-secondary">
            <i className="icofont-edit text-success"></i>
        </Link>
    );
};

export default EditButton;